var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.66144L12.6771 0.984331C13.3229 0.338556 14.3699 0.338557 15.0157 0.984331C15.6614 1.6301 15.6614 2.67711 15.0157 3.32289L10.3386 8L15.0157 12.6771C15.6614 13.3229 15.6614 14.3699 15.0157 15.0157C14.3699 15.6614 13.3229 15.6614 12.6771 15.0157L8 10.3386L3.32289 15.0157C2.67711 15.6614 1.6301 15.6614 0.984331 15.0157C0.338557 14.3699 0.338557 13.3229 0.984331 12.6771L5.66144 8L0.984331 3.32289C0.338556 2.67711 0.338557 1.6301 0.984331 0.984331C1.6301 0.338557 2.67711 0.338556 3.32289 0.984331L8 5.66144Z",
    fill: "#FC5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelX);
export default __webpack_public_path__ + "static/media/cancelX.7ce49ec57e266c79b4ee355e8c2fb0f3.svg";
export { ForwardRef as ReactComponent };